import { useDispatch, useSelector } from "react-redux";
import { concatMessage, incrementPosition, setIsEnd, setLoadingReply, setMessages, setMessagesArchived } from "../../../features/messagesSlice.js";
import useRequestData from "../../../hooks/useRequestData.js";
import { GREETING_MSG_POST, GREETING_MSG_POST2, GREETING_MSG_POST3, GREETING_MSG_PRE, IS_LOGIN } from "../../../../constants.js";
import { formatMessageData } from "../../../utils/formatData.js";

export default function RestartChatButton() {
    const dispatch = useDispatch();
    const messagesArchived = useSelector(state => state.messages.messagesArchived);
    const messages = useSelector(state => state.messages.messages);
    const deviceId = useSelector(state => state.session.deviceId);
    const position = useSelector(state => state.messages.position);
    const { initializeChat } = useRequestData();

    const handleRestartChat = async () => {
        dispatch(setIsEnd(false));
        dispatch(setLoadingReply(true));
        const restartTime = new Date().toLocaleString();
        const clearCutMessage = {
            content: `Chat restarted at ${ restartTime }`,
            user_id: "system",
        };
        dispatch(setMessagesArchived([...messagesArchived.concat(...messages, clearCutMessage)]));
        const initChatPromise = initializeChat();
        if (IS_LOGIN) { // Post Login
            const greetingMessage = formatMessageData(deviceId, "bot", GREETING_MSG_POST, position);
            dispatch(setMessages([ greetingMessage ]));
            dispatch(incrementPosition());
            await new Promise((resolve) => {
                setTimeout(() => {
                    const greetingMessage2 = formatMessageData(deviceId, "bot", GREETING_MSG_POST2, position);
                    dispatch(concatMessage(greetingMessage2));
                    dispatch(incrementPosition());
                    setTimeout(() => {
                        const greetingMessage3 = formatMessageData(deviceId, "bot", GREETING_MSG_POST3, position);
                        dispatch(concatMessage(greetingMessage3));
                        dispatch(incrementPosition());
                    }, 1000);
                    resolve();
                }, 1000);
            })
        } else { // Pre Login
            const greetingMessage = formatMessageData(deviceId, "bot", GREETING_MSG_PRE, position);
            dispatch(setMessages([ greetingMessage ]));
            dispatch(incrementPosition());
        }
        await initChatPromise;
        dispatch(setLoadingReply(false));
    };

    return (
        <button onClick={ handleRestartChat }>
            Restart Chat
        </button>
    );
};
